import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { articles } from '../../../mocks/articles';
import { useState } from 'react';

const ArticleGrid = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tất cả');

  const categories = ['Tất cả', 'FIFA Online 4', 'Age of Empires', 'Liên Minh Huyền Thoại', 'CS:GO', 'PUBG'];

  const filteredArticles = selectedCategory === 'Tất cả'
    ? articles
    : articles.filter(article => article.game === selectedCategory);

  return (
    <section>
      {/* Category Filter */}
      <div className="flex items-center gap-2 sm:gap-3 mb-6 sm:mb-8 overflow-x-auto pb-2 scrollbar-hide">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg sm:rounded-xl font-inter font-semibold text-xs sm:text-sm transition-all whitespace-nowrap ${
              selectedCategory === category
                ? 'bg-gradient-gaming text-white'
                : 'bg-dark-card text-gray-400 hover:text-white border border-gray-800'
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Section Header */}
      <div className="flex items-center justify-between mb-6 sm:mb-8">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-1 h-6 sm:h-8 bg-gradient-gaming"></div>
          <h2 className="font-exo font-bold text-2xl sm:text-3xl text-white">
            BÀI VIẾT MỚI NHẤT
          </h2>
        </div>
      </div>

      {/* Articles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
        {filteredArticles.map((article, index) => (
          <motion.article
            key={article.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="group bg-dark-card rounded-xl sm:rounded-2xl overflow-hidden border border-gray-800 hover:border-accent-cyan/50 transition-all"
          >
            <Link to={`/bai-viet/${article.slug}`} className="block">
              {/* Image */}
              <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-card via-transparent to-transparent"></div>
                
                {/* Category Badge */}
                <span className="absolute top-3 sm:top-4 left-3 sm:left-4 px-2 sm:px-3 py-1 bg-gradient-gaming text-white text-[10px] sm:text-xs font-semibold rounded-full">
                  {article.game}
                </span>
              </div>

              {/* Content */}
              <div className="p-4 sm:p-5 lg:p-6">
                {/* Title */}
                <h3 className="font-exo font-bold text-base sm:text-lg lg:text-xl text-white mb-2 sm:mb-3 line-clamp-2 group-hover:text-accent-cyan transition-colors">
                  {article.title}
                </h3>

                {/* Excerpt */}
                <p className="text-gray-400 text-xs sm:text-sm mb-3 sm:mb-4 line-clamp-2">
                  {article.excerpt}
                </p>

                {/* Meta */}
                <div className="flex items-center justify-between flex-wrap gap-3">
                  <div className="flex items-center gap-2 sm:gap-3">
                    <img
                      src={article.author.avatar}
                      alt={article.author.name}
                      className="w-7 h-7 sm:w-8 sm:h-8 rounded-full border border-accent-cyan"
                    />
                    <div>
                      <div className="text-white text-xs sm:text-sm font-semibold">{article.author.name}</div>
                      <div className="text-gray-500 text-[10px] sm:text-xs">{article.date}</div>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 sm:gap-4 text-[10px] sm:text-xs text-gray-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </motion.article>
        ))}
      </div>

      {/* Load More */}
      <div className="text-center mt-8 sm:mt-12">
        <button className="px-8 sm:px-10 py-3 sm:py-4 bg-dark-card border-2 border-gray-800 text-white font-inter font-semibold rounded-xl hover:border-accent-cyan hover:bg-accent-cyan/10 transition-all flex items-center gap-2 mx-auto whitespace-nowrap text-sm sm:text-base">
          Xem Thêm Bài Viết
          <i className="ri-arrow-down-line"></i>
        </button>
      </div>
    </section>
  );
};

export default ArticleGrid;
